module.exports = __webpack_public_path__ + "static/media/4_diagram.0bf2a17c.svg";